const GoldAccentLine = ({ className = "" }: { className?: string }) => (
  <div className={`flex items-center justify-center gap-3 ${className}`}>
    <div className="h-px w-12 gold-gradient" />
    <div className="w-1.5 h-1.5 rotate-45 gold-gradient" />
    <div className="h-px w-12 gold-gradient" />
  </div>
);

export default GoldAccentLine;
